module.exports = __webpack_public_path__ + "static/media/menu.69df55a5.svg";